// import from auth apis
import { muesApiSlice } from "../authentication/authentication";
import { addActiveClass } from "Redux/class/class";

export const classApi=muesApiSlice.injectEndpoints({
    endpoints: builder =>({
        // list of query
        getClassList : builder.query({
            query : (queryParams)=>({
                url: 'class',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"classList", id:"LIST"}
            ],
            async onQueryStarted(arg, { dispatch, queryFulfilled, getState }){
                try {
                    const {data} = await queryFulfilled;

                    // Get the current activeTeacher from the state
                    const state = getState();
                    const currentClass = state.class.activeClass;
                    
                    if (currentClass) {
                        // Check if the activeTeacher is still in the updated list
                        const updateActiveClassInformation = data?.find(
                          (classInformation) => classInformation.id === currentClass.id
                        );
                                               
                        // If found, update the activeTeacher in the state
                        if (updateActiveClassInformation) {
                          dispatch(addActiveClass(updateActiveClassInformation));
                        }else{
                            if (data?.length >0) {
                                dispatch(addActiveClass(data[0]))
                            }
                        }
                    } else{
                        if (data?.length > 0) {
                            dispatch(addActiveClass(data[0]))
                        }
                    }
                } catch (error) {
                    console.log('Error while fetching class list:', error);
                }
            }
        }),
        getProgramList : builder.query({
            query : ()=>({
                url: 'program',
                method: 'GET',
            }),
        }),
        getClassInformation : builder.query({
            query : (queryParams)=>({
                url: 'class',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"classInformation", id:"LIST"}
            ]
        }),
        getClassFeesInformation : builder.query({
            query : (queryParams)=>({
                url: 'fees',
                method: 'GET',
                params: queryParams,
            }),
            
            providesTags:()=>[
                {type:"classFeesInformation", id:"LIST"},
                {type:"paidFeesInformation", id:"LIST"},
            ]
        }),
        getPaidFeesInformation : builder.query({
            query : (queryParams)=>({
                url: 'paid-fees',
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"paidFeesInformation", id:"LIST"}
            ]
        }),
        getClassTeacherList : builder.query({
            query : (queryParams)=>({
                url: "teacher_class_list",
                method: 'GET',
                params: queryParams,
            }),
            providesTags:()=>[
                {type:"classTeacherList", id:"LIST"}
            ]
        }),
        // list of mutation
        addNewClassInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'class/',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classList", id:"LIST"}
            ]
        }),
        addPaidFeesInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'paid-fees',
                method: 'PATCH',
                body: requestBody,
              }),
            invalidatesTags:()=>[
                {type:"paidFeesInformation", id:"LIST"},
                { type: 'studentFeesInformation', id: "LIST" }
            ]
        }),
        addClassFeesInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'fees',
                method: 'POST',
                body: requestBody,
              }),
            invalidatesTags:()=>[
                {type:"classFeesInformation", id:"LIST"}
            ]
        }),
        editClassInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'class/',
                method: 'PUT',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classList", id:"LIST"},
            ]
        }),
        editClassFeesInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'fees',
                method: 'PUT',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classFeesInformation", id:"LIST"}
            ]
        }),
        deleteClassInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'class/',
                method: 'DELETE',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classList", id:"LIST"},
            ]
        }),
        deleteClassFeesInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'fees',
                method: 'DELETE',
                body: requestBody,
              }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classFeesInformation", id:"LIST"}
            ]
        }),
        editClassSubFeesInformation : builder.mutation({
            query : (requestBody)=>({
                url : 'sub-fees',
                method: 'PUT',
                body: requestBody,
            }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classFeesInformation", id:"LIST"}
            ]
        }),
        deleteClassSubFeesInformation : builder.mutation({
            query: (requestBody) => ({
                url: 'sub-fees',
                method: 'DELETE',
                body: requestBody,
            }),
            invalidatesTags:(result, error, arg)=>[
                {type:"classFeesInformation", id:"LIST"}
            ]
        })
    })
})

export const {useGetClassListQuery, useGetClassInformationQuery,
    useAddNewClassInformationMutation, useEditClassInformationMutation,
    useDeleteClassInformationMutation, useGetProgramListQuery, useGetClassFeesInformationQuery,
    useAddClassFeesInformationMutation, useEditClassFeesInformationMutation, useDeleteClassFeesInformationMutation,
    useGetPaidFeesInformationQuery, useAddPaidFeesInformationMutation, useGetClassTeacherListQuery, useEditClassSubFeesInformationMutation, useDeleteClassSubFeesInformationMutation
}=classApi